(function() {
    $(document).ready(function() {
        var $expandIconTrigger = $('.js-service-expand-icon-button');

        $expandIconTrigger.click(function() {
            var $childServices = $(this).siblings('.service-info').find('.child-service-list');

            if($childServices.children().length > 0) {
                if($childServices.css('display') == "none") {
                    $childServices.slideDown("slow");
                    $(this).html("<i class='bts bt-minus'></i>");
                }
                else {
                    $childServices.slideUp("slow");
                    $(this).html("<i class='bts bt-plus'></i>");
                }
            }
        });


    });
})();